export default __webpack_public_path__ + "static/media/83t.cae816e4.jpg";